{
	"isDesignedForDesktopAnd": "{{var0}} is designed for desktop and laptop usage.",
	"title": "Your device is not compatible"
}
